import { Injectable } from '@angular/core';
// import { GraphicConfig } from '@mare-common/ngx-dynamic-dashboard/lib/plotly/model/graphic-config';
// import { YAxis } from '@mare-common/ngx-dynamic-dashboard/lib/plotly/model/y-axis';
// import { CardContainerConfig } from '@mare-common/ngx-dynamic-dashboard/lib/dynamic-dashboard/dynamic-dashboard-card/model/card-container-config';
import { CardContainerConfig, GraphicConfig, GraphicFactory, YAxis } from '@mare-common/ngx-dynamic-dashboard';
// import { GraphicFactory } from '@mare-common/ngx-dynamic-dashboard/lib/plotly/factory/graphic_factory';

//ChartType: 'LINE' | 'BAR' | 'PIE' | 'INDICATOR' | 'TABLE' | 'RADAR' | 'FUNNEL' | 'BUBBLE' | 'HEATMAP';
// export enum ChartTypes {
//   LINE = 'LINE',
//   BAR = 'BAR',
//   PIE = 'PIE',
//   INDICATOR = 'INDICATOR',
//   TABLE = 'TABLE',
//   RADAR = 'RADAR',
//   FUNNEL = 'FUNNEL',
//   BUBBLE = 'BUBBLE',
//   HEATMAP = 'HEATMAP',
// }
export type ChartTypes = 'LINE' | 'BAR' | 'PIE' | 'INDICATOR' | 'TABLE' | 'RADAR' | 'FUNNEL' | 'BUBBLE' | 'HEATMAP';

@Injectable({
  providedIn: 'root'
})
  

export class ChartBuilderService {

  constructor() { }

  

  /**
   * A function to build a Plotly chart.
   *
   * @param {any} id - the id of the chart
   * @param {ChartTypes} chartType - the type of chart
   * @param {string} title - the title of the chart
   * @param {string} label - the label of the chart
   * @param {string} idValue - the value of the chart's id
   * @param {any} value - the value to be displayed on the chart
   * @param {string} [height] - the height of the chart
   * @param {string} [width] - the width of the chart
   * @param {string} [numericUnit] - the numeric unit for the chart
   * @param {string} [fontColor] - the font color for the chart
   * @param {string} [helpKey] - the help key for the chart
   * @param {string} [iconHeader] - the icon header for the chart
   * @return {Object} an object containing the graphic, graph configuration, and card container configuration
   */

  buildPlotlyChart(id:any, chartType:ChartTypes, title: string, label:string, idValue:string, value:any, height?: string, width?: string, numericUnit?: string, fontColor?: string, helpKey?: string, iconHeader?:string) {

		let el = new GraphicConfig(
		  id,
      chartType, null,
		  title,
		  null,
		  null,
		  null,
		  [
			new YAxis(id, null, "", label, idValue, label, fontColor)
		  ]
		)
		if (numericUnit && el.yaxis) {
		  for (const yAxis of el.yaxis) {
			yAxis.numericUnit = numericUnit;
		  }
		}
		el.values = [{ [idValue]: value }];
	
		el.height = height ? height : '75';
	
		el.width = width ? width : '100';
	
		el.fontColor = fontColor ? fontColor : undefined;
		el.fontSize = '30';
	
	
		let graphData = GraphicFactory.createGraphic(el, el.values);
		let elCard = new CardContainerConfig(
		  el.id,
		  el.title,
		  el.requestFilterDates,
		  'card-' + idValue,
		  null,
		  el.height,
		  null,
		  true
		);
		elCard.helpKey = helpKey ? helpKey : undefined;
		elCard.iconHeader = iconHeader ? iconHeader : undefined;
		let graphic = { data: null, options: null, layout: null, config: null }
		graphic.data = graphData.graphicData
		graphic.options = graphData.graphicOptions
		graphic.layout = graphData.graphicLayout
		graphic.config = graphData.config
	
		return { graphic: graphic, graphConfiguration: el, cardContainerConfig: elCard }
  }

  /**
   * A function to build a chart.
   *
   * @param {any} id - the id of the chart
   * @param {ChartTypes} chartMode - the type of chart
   * @param {string} title - the title of the chart
   * @param {string} idTable - the id of the table
   * @param {string} idXaxis - the id of the x-axis
   * @param {string} idValue - the id of the value
   * @param {any} values - the values for the chart
   * @param {string} label - the label for the chart
   * @param {string} [height] - the height of the chart (optional)
   * @param {string} [width] - the width of the chart (optional)
   * @param {string} [numericUnit] - the numeric unit for the chart (optional)
   * @param {string} [fontColor] - the font color for the chart (optional)
   * @param {string} [helpKey] - the help key for the chart helpInline(optional)
   * @param {string} [helpTitle] - the help title for the chart helpInline (optional)
   * @param {string} [helpDescription] - the help description for the chart helpInline (optional)
   * @return {Object} an object containing the graphic, graphConfiguration, and cardContainerConfig
   */
  buildChart(id: any, chartMode: ChartTypes, title: string, titleCard: string, idTable: string, idXaxis: string, idValue: string, values: any, label: string, height?: string, width?: string, numericUnit?: string, fontColor?: string, helpTitle?: string, helpDescription?: string, helpKey?: string) {

    if (!chartMode) {
      chartMode = 'BAR'
    }

    let el = new GraphicConfig(
      id,
      chartMode, null,
      title,
      null,
      null,
      null,
      [
        new YAxis(id, null, idTable, idXaxis, idValue, label, fontColor)
      ]
    )
    if (numericUnit && el.yaxis) {
      for (const yAxis of el.yaxis) {
        yAxis.numericUnit = numericUnit;
      }
    }
    
    el.values = values;

    el.height = height;

    el.width = width;

    el.fontColor = fontColor ? fontColor : undefined;


    let graphData = GraphicFactory.createGraphicObj(el, el.values);
    let elCard = new CardContainerConfig(
      el.id,
      titleCard,
      el.requestFilterDates,
      'card-' + idValue,
      null,
      el.height,
      null,
      true
    );
    if(helpTitle || helpDescription) {
      elCard.helpTitle = helpTitle ? helpTitle : undefined;
      elCard.helpDescription = helpDescription ? helpDescription : undefined;
      elCard.helpWidth = '650px'
    }
    // elCard.helpKey = helpKey ? helpKey : undefined;
    let graphic = { data: null, options: null, layout: null, config: null }
    graphic.data = graphData.graphicData;
    graphic.options = graphData.graphicOptions
    graphic.layout = graphData.graphicLayout
    graphic.config = graphData.config

    return { graphic: graphic, graphConfiguration: el, cardContainerConfig: elCard }
  }

  buildChartAverages(anni: any[], id: string, value: any, averageValue: any, title: string, title1: string, title2: string, colorValues: any, colorAverage: any, helpTitle?: string, helpDescription?: string) {
    let aa = anni;

    let vals: any = {
      mine: value,
      clustered: averageValue
    }
    let comparedGraphConfig = new GraphicConfig(
      id, 'BAR', 'OTHER',
      title,
      null,
      null,
      null,
      [
        new YAxis(id, null, "mine", "year", "data", title1, colorValues),
        new YAxis(id, null, "clustered", "year", "data", title2, colorAverage)
      ]
    )
    comparedGraphConfig.values = vals;

    comparedGraphConfig.height ='400';

    comparedGraphConfig.width = '400';

    // comparedGraphConfig.width = '300';
    // comparedGraphConfig.height = '300';
    comparedGraphConfig.barmode = 'group';
    comparedGraphConfig.xaxesType = 'category';

    let graphData = GraphicFactory.createGraphicObj(comparedGraphConfig, comparedGraphConfig.values);
    let elCard = new CardContainerConfig(
      comparedGraphConfig.id,
      title,
      comparedGraphConfig.requestFilterDates,
      'card-' + id,
      null,
      comparedGraphConfig.height,
      null,
      false
    );
    if(helpTitle || helpDescription) {
      elCard.helpTitle = helpTitle ? helpTitle : undefined;
      elCard.helpDescription = helpDescription ? helpDescription : undefined;
      elCard.helpWidth = '650px'
    }
    let config = {
			displayModeBar: false,
			modeBarButtonsToRemove: ['toImage'],
			displaylogo: false,
    }
    
    let layoutAnimations = {
      transition: {
        duration: 1000,
        easing: 'easeIn',
      },
      frame: {
        duration: 500
      }
    }

    /** Se devi animare occorre definire  graphic.layout.yaxis.range come array di valore minimo e massimo di range */
   
    graphData.graphicLayout = Object.assign(graphData.graphicLayout, layoutAnimations);
   
    let graphic = { data: null, options: null, layout: null, config: null }
    graphic.data = graphData.graphicData;
    graphic.options = graphData.graphicOptions
    graphic.layout = graphData.graphicLayout
    graphic.config = graphData.config

    return { graphic: graphic, graphConfiguration: comparedGraphConfig, cardContainerConfig: elCard }
  }
  
}
